exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-7e2ac7b4] .el-dialog {\n  width: 4.375rem;\n}\nvideo[data-v-7e2ac7b4] {\n  display: block;\n  margin: 0.104167rem auto;\n  max-width: 90%;\n}", ""]);

// exports
